import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { I18NextService } from 'angular-i18next';
import { GlobalActions } from 'core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class DisplayConcurrencyConflictErrorInterceptor implements HttpInterceptor {
    constructor(private i18: I18NextService) {}

    public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            catchError(err => {
                if (err instanceof HttpErrorResponse && err.status === 409) {
                    try {
                        GlobalActions.displayError(err.error || this.i18.t('shared:notifications.conflictError'), GlobalActions.InfiniteInterval);
                    } catch (e) {
                        return throwError(e.message);
                    }
                }
                return throwError(err);
            })
        );
    }
}
